exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control-lookup-editor-wrapper[data-v-6bfd1ba3] {\n  display: flex;\n  align-items: center;\n}\n.control-lookup-editor-wrapper > button[data-v-6bfd1ba3] {\n  margin-left: 10px;\n  flex-shrink: 0;\n}\n.control-lookup-editor-wrapper > button[data-v-6bfd1ba3]:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n", ""]);

// exports
